/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { defineMessages } from 'react-intl';

const messages = defineMessages({
  error: {
    id: 'components.notifications.error',
    defaultMessage: 'Error'
  },
  info: {
    id: 'components.notifications.info',
    defaultMessage: 'Information'
  },
  success: {
    id: 'components.notifications.success',
    defaultMessage: 'Success'
  },
  warning: {
    id: 'components.notifications.warning',
    defaultMessage: 'Warning'
  },
  viewErrors: {
    id: 'components.notifications.viewErrors',
    defaultMessage:
      'View {errorsCount, plural, =0 {zero} one {# error} other {# errors}}.'
  },
  dismiss: {
    id: 'components.notifications.dismiss',
    defaultMessage:
      'Dismiss {errorsCount, plural, =0 {zero} one {# error} other {# errors}}.'
  },
  transactionId: {
    id: 'components.notifications.transactionId',
    defaultMessage: 'Transaction id: {id}'
  },
  reviewDoc: {
    id: 'components.notifications.reviewDoc',
    defaultMessage: 'Review the <a>documentation</a>'
  },
  goToActions: {
    id: 'components.notifications.goToActions',
    defaultMessage: 'Go to actions'
  },
  actionable: {
    id: 'components.notifications.actionable',
    defaultMessage: 'actionable'
  },
  sslConfigured: {
    id: 'elasticInstance.sslConfigured',
    defaultMessage: `SSL/TLS is configured.`
  },
  sslConfiguredDescription: {
    id: 'elasticInstance.sslConfiguredDescription',
    defaultMessage: `You may need to update your <a>assistant settings</a>`
  }
});

export default messages;
